/// <reference path="/js/lib/jquery/jquery-1.9.1.js"/>
/// <reference path="/js/lib/jquery/jquery.colorbox-min.js"/>
/// <reference path="/js/lib/jquery/jquery.fileDownload.js"/>
/// <reference path="/js/lib/lodash.js"/>
/// <reference path="/js/global.js"/>
(function($, _) {
  "use strict";
  var ns = nspace("ccc.components.ui");

  /**
   * Offers common functionality for all consumers of colorbox downloaders.
   */
  ns.ColorboxDownloader = function(
    $el,
    colorBoxHref,
    downloadHref,
    downloadClasses,
    noDisplayClass,
    timeoutLength,
    method, // e.g. GET, POST. Default is GET.
    postData,
  ) {
    var self = this;

    this.$el = $el;
    this.colorBoxHref = colorBoxHref;
    this.downloadHref = downloadHref;
    this.downloadClasses = downloadClasses;
    this.noDisplayClass = noDisplayClass;
    this.timeoutLength = timeoutLength;
    this.method = method;
    this.postData = postData;
    _.bindAll(self);
  };

  (function(proto) {
    proto.download = function() {
      var colorboxExec,
        self = this,
        downloadFinished = false;

      colorboxExec = function() {
        self.$el.colorbox({
          inline: true,
          href: self.colorBoxHref,
          height: 200,
          onComplete: function() {
            $(self.downloadClasses.failure).attr("class", self.noDisplayClass);

            var noItemsSelected = $("#no-items-selected").val();

            if (noItemsSelected === "true") {
              $(self.downloadClasses.waiting).attr(
                "class",
                self.noDisplayClass,
              );
              $(self.downloadClasses.no_selection).removeClass(
                "class",
                self.noDisplayClass,
              );
              self.$el.colorbox.resize({ width: 300 });
            }
            else {
              $(self.downloadClasses.waiting).removeClass(self.noDisplayClass);
              $(self.downloadClasses.no_selection).attr(
                "class",
                self.noDisplayClass,
              );
              self.$el.colorbox.resize({ width: 205 });
            }
          },
          scrolling: false,
          transition: "none",
        });
      };
      colorboxExec();

      if (self.method === "POST" && window.fetch) {
        var _resp;
        fetch(self.downloadHref, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "same-origin",
          body: JSON.stringify(self.postData),
        })
          .then(resp => {
            _resp = resp;
            return resp.blob();
          })
          .then(blob => {
            // get filename set by backend
            var key = "filename=";
            var disposition = _resp.headers.get("content-disposition"); // e.g. "attachment; filename="CCC Data Download_20200714_113735517.zip""
            var filename = disposition.substring(disposition.indexOf(key) + key.length, disposition.length)
              .replace(/^\"+|\"+$/g, ""); // trim starting and trailing quotes

            // download the file
            var url = window.URL.createObjectURL(blob);
            var a = document.createElement("a");
            a.style.display = "none";
            a.href = url;
            a.setAttribute("download", filename);
            document.body.appendChild(a);
            a.click();

            // cleanup
            downloadFinished = true;
            window.URL.revokeObjectURL(url);
            self.$el.colorbox.close();
          })
          .catch(handleDownloadError);
      }
      else {
        // legacy jQuery library
        $.fileDownload(self.downloadHref, {
          httpMethod: self.method || "GET",
          data: self.method === "POST" ? self.postData : undefined,
          successCallback: function() {
            self.$el.colorbox.close();
            downloadFinished = true;
          },
          failCallback: function() {
            $(self.downloadClasses.waiting).attr("class", self.noDisplayClass);
            $(self.downloadClasses.failure).removeClass(self.noDisplayClass);
            //$(self.downloadClasses.no_selection).attr("class", self.noDisplayClass);
            $(window).resize(); // trigger the native resize handler
          },
        });
  
        // throw an error in n seconds unless the download request comes back first
        setTimeout(handleDownloadError, self.timeoutLength);
      }

      function handleDownloadError(error) {
        console.error(error);

        if (downloadFinished === false) {
          // make sure colorbox is opened
          if ($("#colorbox").css("display") !== "block") {
            colorboxExec();
          }
          // alert the user
          $(self.downloadClasses.waiting).attr("class", self.noDisplayClass);
          $(self.downloadClasses.failure).removeClass(self.noDisplayClass);
          $(window).resize(); // trigger the native resize handler

          // remove ALL iframes (used only for the async downloads)
          $("iframe").each(function() {
            $(this).remove();
          });
        }
      }
    };
  })(ns.ColorboxDownloader.prototype);
})(jQuery, _);
